import { useEffect, useState } from "react";
import { DebounceInput } from "react-debounce-input";
import MatchTeamName from "../MatchComponents/MatchTeamName";
import { useTranslation } from "react-i18next";

const TournamentTeamsTypeahead = (props) => {
  const { tournament, lobbyTeams, hideEmptySelection, hideLobbyTeam } = props;
  const { t } = useTranslation()
  const [teams, setTeams] = useState(tournament?.teams);
  const [searchText] = useState();
  const [loading, setLoading] = useState(false);

  const onChange = (e) => {
    setLoading(true);
    setTimeout(() => {
      const teamsCopy = [...tournament?.teams];
      if (e.target.value === "") {
        setTeams(tournament?.teams);
        setLoading(false)
        return;
      }
      setTeams(
        teamsCopy.filter((team) =>
          team.partyName.toLowerCase().includes(e.target.value.toLowerCase())
        )
      );
      setLoading(false)
    },200);
  };

  useEffect(() => {
    if (hideLobbyTeam && lobbyTeams) {
      // nascondo i team che sono stati inseriti già nella lobby
      const theTeam = teams.filter((el)=>lobbyTeams.some((t)=>t.partyName === el.partyName))
      setTeams(teams.filter((el)=>!theTeam.includes(el)))
    }
  },[])

  return (
    <div className="container">
      <div className="columns">
        <div className="column col-12">
          <div className="skp-form-control">
            <DebounceInput
              value={searchText}
              type="text"
              minLength={1}
              debounceTimeout={500}
              placeholder={t('teams.searchTeamName')}
              onChange={(e) => onChange(e)}
            />
          </div>
        </div>

        <div className="column col-12">
          <h1 className="skp-text-label skp-text-light">
            {t('teams.typeToSearchTeam')}
          </h1>
          {loading && <div className="loading"></div>}
          <dl>
            {!hideEmptySelection && <dd className="skp-link-primary" onClick={() => props.onSelect(undefined)}>{t('teams.setEmptyTeam')}</dd>}
          {!loading &&
            teams?.filter((el, index) => index < 4).map((team,ind) => (
              
                <dd onClick={() => props.onSelect(team)} key={ind}>
                  <MatchTeamName
                    key={ind}
                    tournament={tournament}
                    teamId={team.partyId}
                    hideTeamLabel={true}
                    hideNameClick
                  />
                </dd>
              
            ))}
            </dl>
          <div className="space-divider-20"></div>
        </div>
      </div>
    </div>
  );
};

export default TournamentTeamsTypeahead;
